import React from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { StaticDateTimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TfiCalendar, TfiInfoAlt } from "react-icons/tfi";

const formatDate = (dateString) => {
  if (dateString) {
    const dateObj = new Date(dateString);
    if (!isNaN(dateObj)) {
      const options = {
        weekday: "short",
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "Europe/Madrid",
      };
      return dateObj.toLocaleDateString("es-ES", options);
    }
  }
  return "Pendiente de fecha";
};

const DateSection = ({
  isPublic,
  matchDate,
  showDateTimePicker,
  onAcceptDate,
  onTogglePicker,
}) => {
  return (
    <SectionCard>
      <SectionHeader>FECHA</SectionHeader>
      <DateRow>
        <TfiCalendar />
        {!showDateTimePicker ? (
          <DateText onClick={onTogglePicker}>
            {formatDate(matchDate)}
          </DateText>
        ) : (
          <DateText>Pendiente fecha</DateText>
        )}
      </DateRow>
      {!isPublic && showDateTimePicker ? (
        <DatePickerWrap>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <StaticDateTimePicker
              ampm={false}
              defaultValue={dayjs()}
              value={matchDate && dayjs(matchDate).isValid() ? dayjs(matchDate) : null}
              onAccept={(newValue) => onAcceptDate(newValue)}
              slotProps={{
                calendar: { firstDayOfWeek: 1 },
                actionBar: { actions: ["accept"] },
              }}
              sx={{
                ".MuiPaper-root": {
                  background: "#1a1a1a",
                  color: "#e9e9e9",
                },
                ".MuiToolbar-root": {
                  color: "#3cffd0",
                },
                ".MuiClock-pin": {
                  background: "#3cffd0",
                },
                ".MuiClockPointer-root": {
                  background: "#3cffd0",
                },
                ".MuiClockPointer-thumb": {
                  border: "2px solid #3cffd0",
                },
                ".Mui-selected": {
                  background: "#3cffd0 !important",
                  color: "#000 !important",
                },
                ".MuiDayCalendar-weekDayLabel": {
                  color: "#949494",
                },
                ".MuiPickersCalendarHeader-label": {
                  color: "#e9e9e9",
                },
                ".MuiSvgIcon-root": {
                  color: "#949494",
                },
              }}
            />
          </LocalizationProvider>
        </DatePickerWrap>
      ) : null}
      {!isPublic ? (
        <InfoNote>
          <TfiInfoAlt />
          <span>
            Desde que se anuncie la partida tenéis que poneros de acuerdo
            cuando jugar y publicar la fecha aquí. Si hay cualquier problema,
            por favor contacta con el admin de tu división.
          </span>
        </InfoNote>
      ) : null}
    </SectionCard>
  );
};

const SectionCard = styled.div`
  background: var(--v-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 1.25rem;
`;

const SectionHeader = styled.h4`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--v-mint);
  margin: 0 0 0.75rem;
`;

const DateRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--v-fg-muted);
  font-size: 13px;
`;

const DateText = styled.span`
  font-family: var(--v-font-body);
  color: var(--v-fg);
  cursor: pointer;

  &:hover {
    color: var(--v-hover);
  }
`;

const DatePickerWrap = styled.div`
  margin-top: 0.75rem;
`;

const InfoNote = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.75rem;
  font-family: var(--v-font-body);
  font-size: 12px;
  font-style: italic;
  color: var(--v-fg-muted);
  line-height: 1.4;

  p {
    margin: 0;
  }
`;

export default DateSection;
